import accountRoutes from './modules/account'

export default [
  {
    path: '/',
    name: 'Index',
    redirect: '/home'
  },
  {
    // 添加属性id的话，会作为菜单显示
    path: '/home',
    name: 'Home',
    meta: {
      title: '首页'
    },
    component: () => import('@/views/home/Index')
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: '登录'
    },
    component: () => import('@/views/login/Index')
  },
  // 登录指南
  {
    path: '/login-guide',
    name: 'LoginGuide',
    meta: {
      title: '登录指南'
    },
    component: () => import(/* webpackChunkName: "LoginGuide" */'@/views/loginGuide/index')
  },
  // 联系我们
  {
    path: '/service-contact',
    name: 'ServiceContact',
    component: () => import(/* webpackChunkName: "ServiceContact" */'@/views/serviceContact/index')
  },
  // 服务协议
  {
    path: '/service-agreement',
    name: 'ServiceAgreement',
    meta: {
      title: 'CBiBank服务协议'
    },
    component: () => import(/* webpackChunkName: "LoginGuide" */'@/views/serviceAgreement/index')
  },
  // 账户管理
  accountRoutes,
  // 404页面
  {
    path: '/404',
    name: '404',
    meta: {
      title: '404'
    },
    component: () => import('@/views/404')
  }
]
